exports.default = {
  case_upload_image: 'Upload image',
  case_recreate_mode: 'Recreation mode',
  case_reference_mode: 'Reference recreation',
  case_reference_hint: 'Use the example’s concept and composition with your uploaded images.',
  case_description: 'Description',
  case_description_placeholder: 'Describe your requirements',
  title_brand: 'PAITEAMS',
  title: 'AI Designer',
  recents: 'Recents',
  preset_categories: 'Preset categories',
  show_category_presets: 'Show {name} presets',
  category_default_preset_unavailable: 'This category has no available default preset',
  category_presets_empty: 'No presets in this category yet',
  category_presets_load_failed: 'Unable to load preset categories',
  retry_category_presets: 'Retry',
  no_recents: 'No image conversations yet',
  new_image_conversation: 'Image generation conversation',
  model: 'Model',
  auto_model: 'Auto select model',
  auto_model_desc: 'Choose the best image model for this task automatically',
  model_default_desc: 'Good for image generation, editing, and visual creation',
  no_image_models: 'No image models available',
  settings: 'Settings',
  image_size: 'Image size',
  aspect_ratio: 'Aspect ratio',
  preset_size: 'Preset size',
  custom_pixels: 'Custom pixels',
  custom_pixels_current: 'Current size',
  custom_pixels_unit: 'pixels',
  custom_pixels_width_limit: 'Width range',
  custom_pixels_height_limit: 'Height range',
  custom_pixels_total_limit: 'Total pixels',
  custom_pixels_step_limit: 'Step size',
  custom_pixels_ratio_limit: 'Long-to-short ratio',
  custom_pixels_within_limits: 'Within model limits',
  width: 'Width',
  height: 'Height',
  custom_pixels_range: '{minWidth}–{maxWidth} px wide, {minHeight}–{maxHeight} px high, step {widthStep}/{heightStep}',
  custom_pixels_limit: 'Total pixels {min}–{max}',
  custom_pixels_required: 'Enter both width and height',
  custom_pixels_integer: 'Width and height must be positive integers',
  custom_pixels_width_range: 'Width must be between {min} and {max} px',
  custom_pixels_height_range: 'Height must be between {min} and {max} px',
  custom_pixels_width_step: 'Width must align to {step} px',
  custom_pixels_height_step: 'Height must align to {step} px',
  custom_pixels_min_total: 'Total pixels cannot be below {min}',
  custom_pixels_max_total: 'Total pixels cannot exceed {max}',
  custom_pixels_min_ratio: 'Aspect ratio cannot be below {min}:1',
  custom_pixels_max_ratio: 'The long-to-short side ratio cannot exceed {max}:1',
  custom_pixels_invalid: 'Custom pixels do not satisfy this model’s limits',
  auto_style: 'Auto style',
  search_style: 'Search style...',
  camera: 'Camera',
  camera_body: 'Camera body',
  lens: 'Lens',
  focal_length: 'Focal length',
  aperture: 'Aperture',
  auto_prompt: 'Auto prompt',
  prompt_placeholder: 'A cute kitten playing with a ball of yarn',
  generate: 'Generate',
  quick_apps: 'Quick apps',
  view_all: 'View all',
  no_cases: 'No cases yet',
  all: 'All',
  album: 'Album',
  album_case_count: '{count} works',
  recommended_albums: 'Recommended albums',
  search_related_albums: 'Related albums',
  search_related_cases: 'Related cases',
  search_case_count: '{count} cases found',
  clear_search: 'Clear search',
  back_to_image_generation: 'Back to AI Images',
  sort_cases: 'Sort cases',
  sort_popular: 'Popular',
  sort_latest: 'Latest',
  sort_default: 'Default',
  case_inspiration: 'Inspiration',
  case_short: 'Shorts',
  case_activity: 'Activities',
  case_search_placeholder: 'Search inspiration',
  hot_category_previous: 'Previous hot cases',
  hot_category_next: 'Next hot cases',
  hot_category_empty: 'No cases in this category',
  prompt: 'Prompt',
  image_prompt: 'Image prompt',
  quality: 'Quality',
  size: 'Size',
  recreate: 'Recreate',
  same_style: 'Same style',
  use_as_reference: 'Use as reference image',
  more: 'More',
  previous_case: 'Previous case',
  next_case: 'Next case',
  case_detail: 'Case detail',
  loading: 'Loading',
  conversation: 'Conversation',
  you: 'You',
  assistant: 'Assistant',
  continue_conversation: 'Continue conversation',
  make_same: 'Make a copy',
  conversation_unavailable: 'This case has no conversation context to continue',
  conversation_create_failed: 'Unable to create a new conversation',
  reference_image_unavailable: 'This case cannot be used as a reference image yet',
  video: 'Generate video',
  download: 'Download',
  zoom: 'Zoom',
  edit: 'Edit',
  save: 'Save',
  copy: 'Copy',
  max_upload_images: 'Upload up to {count} reference images',
  reference_image_upload_hint: 'Each image must not exceed 20MB. The current model supports up to {count} reference images.',
  reference_image_limit_exceeded: 'The current model supports up to {max} reference images. {actual} are selected; remove {remove}.',
  invalid_image_format: 'Image format must be PNG, JPEG, JPG, or WebP',
  image_size_limit: 'Image size cannot exceed 20MB',
  upload_failed: 'Image upload failed',
  no_entry_agent: 'Image generation entry agent was not found',
  no_image_model_selected: 'Please select an image model',
  quick_background_remove: 'Background remove',
  quick_background_remove_prompt: 'Remove the image background and keep the subject clean with natural edges.',
  quick_magic_retouch: 'Magic retouch',
  quick_magic_retouch_prompt: 'Repair unwanted areas while preserving natural material and lighting.',
  quick_scene_redraw: 'Scene redraw',
  quick_scene_redraw_prompt: 'Redraw the scene with richer details, atmosphere, and composition.',
  quick_photo_deblur: 'Photo deblur',
  quick_photo_deblur_prompt: 'Improve photo sharpness and recover people, object, and background details.',
  quick_image_expand: 'Image expand',
  quick_image_expand_prompt: 'Expand the image borders naturally with extended background and scene content.',
  skills: 'Skills',
  all_skills: 'All skills',
  loading_skills: 'Loading skills',
  no_skills: 'No skills available',
  recently_opened: 'Recently opened',
  back_to_categories: 'Back to categories'
}
